import {CreateAccessor, GetDocs, GetDoc} from "mobx-graphlink";
import {TestSegment, SamplesBySecond} from "./testSegments/@TestSegment";

/*function OrderPropsByKey(obj: SamplesBySecond) {
	if (obj == null) return null;
	return obj.Pairs().OrderBy(a=>a.keyNum).ToMapObj(a=>a.key, a=>a.value);
}
function FixSegment(segment: TestSegment) {
	// currently, mutates the segment-data (that's fine)
	segment.channelSamples.eeg_left = OrderPropsByKey(segment.channelSamples.eeg_left);
	segment.channelSamples.eeg_right = OrderPropsByKey(segment.channelSamples.eeg_right);
	return segment;
}*/

export const GetTestSegments = CreateAccessor((userID: string, sessionID?: string): TestSegment[]=>{
	const result = GetDocs({
		params: {filter: {
			creator: userID != null && {equalTo: userID},
			sourceSession: sessionID && {equalTo: sessionID},
		}}
	}, a=>a.testSegments);
	//return result.map(segment=>FixSegment(segment));
	return result;
});
export const GetTestSegment = CreateAccessor((id: string): TestSegment|n=>{
	const result = GetDoc({}, a=>a.testSegments.get(id));
	//return result ? FixSegment(result) : null;
	return result;
});